const initialState = {
    isModalVisible: false,
  };
  
  const termsModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_TERMS_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_TERMS_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default termsModalReducer;
  